export class AccCompareCard {
    constructor(
        public igAccount: string | undefined,
        public image: string | undefined,
        public followers: number | undefined,
        public engagementRate: number | undefined,
        public comments: number | undefined,
        public likes: number | undefined,
        public mediaCount: number | undefined
    ) {}
}
